import { REALTIME_EVENT_TYPES } from "@peekop/core/contracts/events";

export const OBSERVED_EVENT_TYPES = REALTIME_EVENT_TYPES;
